import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useEffect } from "react";

export default function Layout() {
    const { pathname } = useLocation();
    useEffect(() => window.scrollTo({ top: 0, behavior: "instant" }), [pathname]);
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="pt-16 flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
